// extracted by mini-css-extract-plugin
export default {"conditionsToBuyInCredit":"Ao3vC","title":"thzFe","wrapper":"R_npl","alignStart":"sA4ys","condition":"ELjPr","icon":"asWyK","text":"K0Oak"};